import { UUID } from "../../../utils/typeDefinitions";
import IBimVisualizerApiProvider from "../IBimVisualizerApiProvider";
import ApiStoreyDocumentProvider from "../../documentProvider/ApiStoreyDocumentProvider";
import StartupProjectApiDataLoader from "./StartupProjectApiDataLoader";
import User from "../../../model/User";

class SpatialStructureAppDataProvider extends StartupProjectApiDataLoader {
    spatialStructureGlobalId: UUID;
    
    constructor(apiProvider: IBimVisualizerApiProvider, projectGlobalId: UUID, spatialStructureGlobalId: UUID) {
        super(apiProvider, new ApiStoreyDocumentProvider(projectGlobalId, spatialStructureGlobalId, apiProvider), projectGlobalId);        
        this.spatialStructureGlobalId = spatialStructureGlobalId;
    }

    // Load spatial structure model
    loadRootProduct = async () => {
        const result = await this.apiProvider.getSpatialStructureModel(this.projectGlobalId, this.spatialStructureGlobalId);
        return result;
    }
}

export default SpatialStructureAppDataProvider;